module.exports = __webpack_public_path__ + "img/ad1.4cd46979.png";